import ApiStore from './store/module-api';
const Concrete = {
    init (metaDefinition={}){
        ApiStore.state.meta = metaDefinition;
        // add concrete permission to meta
        ApiStore.state.meta.listModels.concretePermissions = {
            url: 'acl/permission/',
            verboseName: 'Concrete permission'
        };
        ApiStore.state.meta.listModels.concreteRoles = {
            url: 'acl/role/',
            verboseName: 'Concrete role'
        };
        // Create entries within store
        for (let modelName in ApiStore.state.meta.listModels){

            ApiStore.state[modelName] = {};
            ApiStore.state.modelsTimestamps[modelName] = '0.0';
            ApiStore.state.modelsFlagLoaded[modelName] = false;
            ApiStore.state.modelsFetchHandler[modelName] = null;
            if(!ApiStore.state.meta.listModels[modelName].stats){
                ApiStore.state[`${modelName}List`] = [];
            }
        }

        // Create associated getters
        for (let modelName in ApiStore.state.meta.listModels){
            let stats = ApiStore.state.meta.listModels[modelName].stats;
            if(!stats){
                ApiStore.getters[modelName] = (state) => {
                    return state[`${modelName}List`].map(objId => state[modelName][objId]);
                };

            }else{
                ApiStore.getters[modelName] = (state) => {
                    return state[modelName];
                };
            }
            ApiStore.getters[`${modelName}ByCreationDate`] = (state, getters) => {
                return getters.getCollectionSorted(
                    getters[modelName], 'creation_date'
                );
            };
            ApiStore.getters[`${modelName}ByModificationDate`] = (state, getters) => {
                return getters.getCollectionSorted(
                    getters[modelName], 'modification_date'
                );
            };
            ApiStore.getters[`${modelName}ByUid`] = state => objId => state[modelName][objId];
        }

        return ApiStore;
    },
};

export default Concrete;



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/concrete.js
// module id = null
// module chunks = 